"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var idm_locale_service_client_js_1 = require("@synisys/idm-locale-service-client-js");
var idm_session_data_provider_api_js_1 = require("@synisys/idm-session-data-provider-api-js");
var operators_1 = require("rxjs/operators");
var from_1 = require("rxjs/observable/from");
/**
 * Transforming message key to message using current language.
 */
var DateFormatterPipe = /** @class */ (function () {
    function DateFormatterPipe(localeService, currentLanguageProvider) {
        this.localeService = localeService;
        this.currentLanguageProvider = currentLanguageProvider;
    }
    DateFormatterPipe.prototype.transform = function (date) {
        var _this = this;
        return this.currentLanguageProvider.getCurrentLanguage()
            .pipe(operators_1.switchMap(function (currentLanguage) {
            return from_1.from(_this.localeService.formatDateTime(date, currentLanguage.getId()));
        }));
    };
    DateFormatterPipe = __decorate([
        core_1.Pipe({
            name: 'dateFormatter',
            pure: true
        }),
        __metadata("design:paramtypes", [idm_locale_service_client_js_1.LocaleService, idm_session_data_provider_api_js_1.CurrentLanguageProvider])
    ], DateFormatterPipe);
    return DateFormatterPipe;
}());
exports.DateFormatterPipe = DateFormatterPipe;
//# sourceMappingURL=date-formatter.pipe.js.map